import React, { Component } from 'react'
import { Carousel, Container } from 'react-bootstrap'
import DSCN6689 from '../jpgforpage/2018/DSCN6689.JPG'
import DSCN6690 from '../jpgforpage/2018/DSCN6690.jpg'
import DSCN6692 from '../jpgforpage/2018/DSCN6692.JPG'
import DSCN6698 from '../jpgforpage/2018/DSCN6698.JPG'
import DSCN6706 from '../jpgforpage/2018/DSCN6706.JPG'
import DSCN6835 from '../jpgforpage/2018/DSCN6835.JPG'
import IMG_9306 from '../jpgforpage/2018/IMG_9306.JPG'
import IMG_9310 from '../jpgforpage/2018/IMG_9310.JPG'
import IMG_9388 from '../jpgforpage/2018/IMG_9388.JPG'
import IMG_9407 from '../jpgforpage/2018/IMG_9407.JPG'
import IMG_9419 from '../jpgforpage/2018/IMG_9419.JPG'





export default class Photo2018 extends Component {
    render() {
        return (
            <Container>
                <Carousel>
                    <Carousel.Item>
                        <img 
                            src={DSCN6689} 
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN6690} 
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN6692} 
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN6698} 
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN6706} 
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN6835} 
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={IMG_9306} 
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={IMG_9310}
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={IMG_9388}
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={IMG_9407}
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                         </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={IMG_9419}
                            className='img-carousel-1'
                            alt="Photo2018"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2018</p>
                         </Carousel.Caption>
                    </Carousel.Item>
                    
                </Carousel> <hr />
            </Container>
        )
    }
}
   
         